import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { People, PublicHolidayApiClient } from '~/services/Http';

export const GET_PUBLIC_HOLIDAYS_SWR_KEY =
  'PublicHolidayApiClient.getPublicHolidays';

export type UseGetPublicHolidaysArgs = {
  legalEntities?: number[];
  countryCodes?: string[];
  years?: number[];
};

export function useGetPublicHolidays(
  args?: UseGetPublicHolidaysArgs,
): UseSWROutput<People.PublicHolidayDto[]> {
  return useSWR(
    [
      GET_PUBLIC_HOLIDAYS_SWR_KEY,
      args?.legalEntities ?? undefined,
      args?.countryCodes ?? undefined,
      args?.years ?? undefined,
    ],
    ([_, legalEntities, countryCodes, years]) =>
      PublicHolidayApiClient.getPublicHolidays(
        legalEntities,
        countryCodes,
        years,
      ).then((r) => r.data),
  );
}
